// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type RequestPlanPackageSlotsModal_CreateIncomingSlotsMutationVariables = Types.Exact<{
  input: Types.CreatePlanPackageIncomingSlotsInput;
}>;


export type RequestPlanPackageSlotsModal_CreateIncomingSlotsMutation = { __typename?: 'Mutation', createPlanPackageIncomingSlots: Array<{ __typename?: 'PlanPackageIncomingSlot', id: string, planPackage: { __typename?: 'PlanPackage', id: string, name: string } }> };


export const RequestPlanPackageSlotsModal_CreateIncomingSlotsDocument = gql`
    mutation RequestPlanPackageSlotsModal_CreateIncomingSlots($input: CreatePlanPackageIncomingSlotsInput!) {
  createPlanPackageIncomingSlots(input: $input) {
    id
    planPackage {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useRequestPlanPackageSlotsModal_CreateIncomingSlotsMutation__
 *
 * To run a mutation, you first call `useRequestPlanPackageSlotsModal_CreateIncomingSlotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPlanPackageSlotsModal_CreateIncomingSlotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPlanPackageSlotsModalCreateIncomingSlotsMutation, { data, loading, error }] = useRequestPlanPackageSlotsModal_CreateIncomingSlotsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPlanPackageSlotsModal_CreateIncomingSlotsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestPlanPackageSlotsModal_CreateIncomingSlotsMutation, RequestPlanPackageSlotsModal_CreateIncomingSlotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestPlanPackageSlotsModal_CreateIncomingSlotsMutation, RequestPlanPackageSlotsModal_CreateIncomingSlotsMutationVariables>(RequestPlanPackageSlotsModal_CreateIncomingSlotsDocument, options);
      }
export type RequestPlanPackageSlotsModal_CreateIncomingSlotsMutationHookResult = ReturnType<typeof useRequestPlanPackageSlotsModal_CreateIncomingSlotsMutation>;
export type RequestPlanPackageSlotsModal_CreateIncomingSlotsMutationResult = ApolloReactCommon.MutationResult<RequestPlanPackageSlotsModal_CreateIncomingSlotsMutation>;